const moment = require('moment')
moment.locale('ru')

export function momentFromString (string) {
  const formats = [
    'DD.MM.YYYY',
    'YYYY-MM-DD',
    'DD.MM.YYYY HH:mm:ss',
    'YYYY-MM-DDTHH:mm:ssZ',
    'YYYY-MM-DDTHH:mm:ssz'
  ]
  const m = moment(string, formats, 'ru')
  if (m.isValid()) {
    return m
  } else {
    // console.log('moment can\'t parse datetime', string)
    return null
  }
}
